import Vue from "vue";
import orderiomApiPackage, {defineInterceptors} from "orderiom-api-package";

Vue.prototype.$storage = process.env.VUE_APP_S3_STORAGE;
Vue.prototype.$initialProductExtraInfo = JSON.stringify({comment: '', itemDetails: []});
Vue.prototype.$http = orderiomApiPackage.$http;
Vue.prototype.$weekdays = orderiomApiPackage.weekdays;
Vue.prototype.$itemCommentMaxLength = 140;
Vue.prototype.$toLocalCurrency = (value) => {
	const initialValue = Number(value);
	// No change performed
	if(isNaN(initialValue) || !window.moneyCurrency) return value;

	return initialValue.toLocaleString(
		window.moneyLang || 'de',
		{
			style: 'currency',
			currency: window.moneyCurrency,
		}
	)
}
Vue.prototype.$getExternalOrderTable = function(){
	const slug = this.$store.getters.restaurantSlug;
	if(!slug) return null;

	const data = JSON.parse(localStorage.getItem('externalOrderTable') || "{}");
	return data[slug] ? {tableName: data[slug]} : null;
}
Vue.prototype.$defineInterceptors = defineInterceptors;
